import ReducerRegistry from "../../../base/redux/ReducerRegistry";
// @ts-ignore
import { FEATURE_CUSTOM_REDUX_V4 } from "../../constant";
import { SET_USER_SUBSCRIPTION_MODAL } from "./actionType";
const DEFAULT_STATE = {
    userSubscriptionModel: false
};
ReducerRegistry.register(FEATURE_CUSTOM_REDUX_V4, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_USER_SUBSCRIPTION_MODAL: {
            return {
                ...state,
                userSubscriptionModel: action.userSubscriptionModel
            };
        }
    }
    return state;
});
